import { useTranslation } from 'react-i18next';
import { TextVariant } from 'src/components/atoms/Text';
import { BankAccount } from 'src/hooks/useBankLinking';
import { Account } from 'src/types/applicantExperienceApi';
import {
  AccountLogoImage,
  AccountText,
  ConnectedAccount,
  ConnectedAccounts,
  DisconnectLink
} from './styles';

type ConnectedAccountType = Account | BankAccount;

interface ConnectedAccountsListProps {
  connectedAccounts: ConnectedAccountType[];
  disconnectAccount: (accountId: string) => void;
}

export const ConnectedAccountsList = ({
  connectedAccounts,
  disconnectAccount
}: ConnectedAccountsListProps) => {
  const { t } = useTranslation();

  return (
    <ConnectedAccounts>
      {connectedAccounts.map((connectedAccount) => (
        <ConnectedAccount key={connectedAccount.accountId}>
          <AccountLogoImage
            alt={
              'accountName' in connectedAccount
                ? connectedAccount.institutionName
                : connectedAccount.name
            }
            src={connectedAccount.logoUrl}
          />
          <AccountText variant={TextVariant.small}>
            {'accountName' in connectedAccount
              ? connectedAccount.institutionName
              : connectedAccount.name}
          </AccountText>
          {'accountNumberDisplay' in connectedAccount && (
            <AccountText variant={TextVariant.small}>
              {connectedAccount.accountName}: ...{connectedAccount.accountNumberDisplay}
            </AccountText>
          )}
          <DisconnectLink onClick={() => disconnectAccount(connectedAccount.accountId)}>
            {t('dup.wizard.disconnect')}
          </DisconnectLink>
        </ConnectedAccount>
      ))}
    </ConnectedAccounts>
  );
};

export default ConnectedAccountsList;
